// extracted by mini-css-extract-plugin
export default {"item":"JuriItem_item__3nikY","emptyImage":"JuriItem_emptyImage__DScw+"};